





















































import Vue from 'vue'
import Component from 'vue-class-component'
import { ERecipientType } from '@zunta/configurations/dist/types/resident'
import Icon from '@/components/Icon.vue'
import { ELetterStatus, ILetter, IResidentContact } from '@zunta/configurations'
import StatusLetter from '@/components/statuses/StatusLetter.vue'
import { LettersModule } from '@/store/modules/letters.module'
import { getModule } from 'vuex-module-decorators'

@Component({
  components: { StatusLetter, Icon },
  props: {
    letter: {
      type: Object,
      required: true
    },
    residentContacts: {
      type: Array,
      required: true
    }
  }
})
export default class LetterResidentContact extends Vue {
  ERecipientType: any = ERecipientType
  ELetterStatus = ELetterStatus
  letterModuleInstance: LettersModule = getModule(LettersModule, this.$store)

  async dontBillLetterStatusChange (letter: ILetter) {
    const status = ELetterStatus.RETURNED === letter.status ? ELetterStatus.DO_NOT_BILL_RETURNED : ELetterStatus.DO_NOT_BILL_EMAIL_RETURNED
    return this.changeStatus(letter, status)
  }

  async changeStatus (letter: ILetter, status: ELetterStatus) {
    await this.letterModuleInstance.changeLetterStatus({ letterId: letter.id, status })
    this.$emit('statusChange')
  }

  get letterId () {
    return this.$route.params.letter
  }

  get contact () {
    if (!this.$props.residentContacts || !this.$props.residentContacts.length) {
      return null
    }
    return this.$props.residentContacts.find((contact: IResidentContact) => contact.id === this.$props.letter.recipient.mailContact)
  }

  get residentEmail () {
    if (!this.contact) {
      return ''
    }
    return this.contact.email
  }

  get residentAddress () {
    if (!this.contact) {
      return ''
    }
    return (this.contact.addressLine1 ? this.contact.addressLine1 : '') + ' ' +
        (this.contact.addressLine2 ? this.contact.addressLine2 : '') + ' ' +
        (this.contact.addressLine3 ? this.contact.addressLine3 : '') + ' ' +
        (this.contact.city ? this.contact.city : '') + ', ' +
        (this.contact.state ? this.contact.state : '') + ' ' +
        (this.contact.zipCode ? this.contact.zipCode : '')
  }
}
